export enum TestMethodType {
  Regular = 0,
  ShadeEvaluation = 1
}
